import LandingPageFeatures from '@/app/components/LandingPage/LandingPageFeatures';

import metabolicHealthFeaturesData from './_data/metabolicHealthFeaturesData';
import { metabolicHealthFeaturesGradients } from './_data/metabolicHealthFeaturesGradients';

const MetabolicHealthFeatures = () => {
  return (
    <section
      className="pt-20 pb-4 lg:py-11"
      data-cy="metabolic-health-features"
    >
      <LandingPageFeatures
        className="relative"
        eyebrow="activity_features_eyebrow"
        features={metabolicHealthFeaturesData}
        theme="dark"
        imageGradientBg={{
          className: 'bg-mustard-100',
          gradients: metabolicHealthFeaturesGradients,
        }}
        textColor="mustard-700"
      />
    </section>
  );
};

export default MetabolicHealthFeatures;
